import React from "react";

function Products() {
  const items = [
    {
      title: "Tuna in Extra Virgin Olive Oil Blend",
      desc: "175g premium yellow tuna chunks packed in rich olive oil.",
      img: "/images/Finished_Olive_Front.png"
    },
    {
      title: "Tuna in Springwater",
      desc: "175g premium yellow fin tuna chunks packed in natural springwater.",
      img: "/images/Finished_Springwater_Front.png"
    },
    {
      title: "Tuna in Extra Virgin Avocado Oil Blend",
      desc: "175g premium yellow fin tuna chunks packed in rich avocado oil.",
      img: "/images/Finished_Avocado_Front.png"
    }
  ];

  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold mb-10 text-blue-900">Our Products</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-lg p-6 hover:scale-105 transition">
              <img src={item.img} alt={item.title} className="mx-auto rounded-xl mb-4" />
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 mt-2">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
